import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { MODULES } from "../../config/landingConfig";
import { Reveal } from "./Reveal";
import { SectionTag } from "./decorations";

export const Program = () => (
  <section id="program" data-testid="program-section" className="scroll-mt-24 bg-blush">
    <div className="mx-auto max-w-5xl px-4 py-20 sm:px-6 lg:py-28">
      <Reveal>
        <SectionTag number="04" label="Program" color="bg-cyan" />
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="mt-6 text-2xl font-extrabold uppercase tracking-tight text-ink sm:text-3xl lg:text-4xl">
          Program kursu - <span className="marker-cyan">6 modułów</span>
        </h2>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-ink/70 sm:text-lg">
          Każdy moduł to konkretny etap pracy: od metodyki, przez prompty, po gotowe
          gry do druku i interaktywne. Rozwiń moduł, aby zobaczyć zakres.
        </p>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="multiple" className="mt-10 space-y-4" data-testid="program-accordion">
          {MODULES.map((mod, i) => (
            <AccordionItem
              key={mod.title}
              value={`modul-${i + 1}`}
              data-testid={`program-module-${i + 1}`}
              className="rounded-2xl border-2 border-ink bg-white px-5 shadow-hard-sm sm:px-7"
            >
              <AccordionTrigger
                data-testid={`program-module-trigger-${i + 1}`}
                className="py-5 text-left hover:no-underline [&[data-state=open]>svg]:rotate-180"
              >
                <span className="flex items-center gap-4">
                  <span className="font-display hidden rounded-xl border-2 border-ink bg-violet px-3 py-1 text-sm text-white sm:block">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="text-base font-extrabold text-ink sm:text-lg">
                    <span className="mr-2 text-xs font-bold uppercase tracking-wider text-ink/50 sm:hidden">
                      Moduł {i + 1}.
                    </span>
                    {mod.title}
                  </span>
                </span>
              </AccordionTrigger>
              <AccordionContent
                data-testid={`program-module-content-${i + 1}`}
                className="pb-6 text-sm leading-relaxed text-ink/75 sm:pl-[4.25rem] sm:text-base"
              >
                <p>{mod.text}</p>
                <ul className="mt-4 space-y-2.5">
                  {mod.lessons.map((lesson) => (
                    <li key={lesson.t} className="flex items-start gap-2.5">
                      <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rotate-45 border border-ink bg-cyan" aria-hidden="true" />
                      <span>
                        {lesson.d ? (
                          <>
                            <strong className="font-extrabold text-ink">{lesson.t}</strong>
                            {" - "}
                            {lesson.d}
                          </>
                        ) : (
                          lesson.t
                        )}
                      </span>
                    </li>
                  ))}
                </ul>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
